/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {SET_PROFILE_TIMEOUT_OR_ERROR, SET_PAGE_VISIT_COUNT} from '../types';

/* eslint-disable space-before-function-paren */

export const resetProfileFetchError = () => async (dispatch: Function) => {
	dispatch({
		type: SET_PROFILE_TIMEOUT_OR_ERROR,
		payload: false,
	});
};

/* eslint-enable space-before-function-paren */
